//////////////////////////////////////////////////
// 規約同意＆gift同意チェックボックス
//////////////////////////////////////////////////
const isAgreeGiftOrderCheck = document.getElementById('isAgreeGiftOrderCheck');
const termsCheck = document.getElementById('termsCheck');
const submit = document.getElementById('checkout');
function updateSubmitState() {
  if (submit) {
    // 規約同意のチェックがついている場合、もしくは、gift同意があり、かつチェックがある場合のみボタンを有効化
    submit.disabled = !(termsCheck?.checked && (isAgreeGiftOrderCheck?.checked ?? true));
  }
}

if (termsCheck) {
  termsCheck.addEventListener('change', updateSubmitState);
}

if (isAgreeGiftOrderCheck) {
  isAgreeGiftOrderCheck.addEventListener('change', updateSubmitState);
}

// 初期状態のチェック（ページ読み込み時）
updateSubmitState();

//////////////////////////////////////////////////
// カートを空にするボタンクリックイベント
//////////////////////////////////////////////////
const allClearCart = document.getElementById('all_clear_cart');
if (allClearCart) {
  allClearCart.addEventListener('click', () => {
    if (!confirm('本当にカートを空にしますか？')) return;
    fetch('/cart/clear', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`${response.status} ${response.statusText}`);
        }
        location.reload();
      })
      .catch((error) => {
        console.error(error);
      });
  });
}

//////////////////////////////////////////////////
// レジに進むボタンクリックイベント
//////////////////////////////////////////////////
if (submit) {
  submit.addEventListener('click', async function (e) {
    try {
      e.preventDefault();

      var view = e.currentTarget.dataset.cart_view;
      let els = document.getElementsByClassName('quantity__input');
      let islimitCountOver = false;

      let eitherOneCntByProduct = {};
      let isExistEitherOne = false;

      let isError = false;
      let errorMessages = [window.purchaseLimitErrorStrings.cartPurchaseLimitErrorTitle];

      for (let i = 0; i < els.length; i++) {
        if (els[i].getAttribute('data-limit-count') && Number(els[i].value) > Number(els[i].getAttribute('data-limit-count'))) {
          islimitCountOver = true;
        }

        if (els[i].getAttribute('data-is-either-one') == 'true') {
          if (els[i].getAttribute('data-pid') in eitherOneCntByProduct) {
            eitherOneCntByProduct[els[i].getAttribute('data-pid')] += 1;
          } else {
            eitherOneCntByProduct[els[i].getAttribute('data-pid')] = 1;
          }
        }
      }

      const entries = Object.entries(eitherOneCntByProduct);
      for (const [pid, count] of entries) {
        if (count > 1) {
          isExistEitherOne = true;
        }
      }

      if (islimitCountOver === true) {
        isError = true;
        errorMessages.push('・' + window.purchaseLimitErrorStrings.cartPurchaseLimitErrorLimitOver);
      }

      if (isExistEitherOne === true) {
        isError = true;
        errorMessages.push('・' + window.purchaseLimitErrorStrings.cartPurchaseLimitErrorNotBundled);
      }

      if (isError === true) {
        alert(errorMessages.join('\n'));
        //e.currentTarget.removeAttribute('data-loading');
        return false;
      }

      const isIncluedGift = document.querySelector('#isIncluedGift')?.dataset.isincluedgift;
      const isIncluedPreOrderProduct = document.querySelector('#isIncluedPreOrderProduct')?.dataset.isincluedpreorderproduct;

      if (isIncluedGift == 'false' && isIncluedPreOrderProduct == 'false') {
        if (typeof lotteryModule.mainLottery == 'function') await lotteryModule.mainLottery(view);
      }

      const cartForm = document.getElementById('cart');
      cartForm.action = '/checkout';
      cartForm.submit();
    } catch (e) {
      console.error('[Exception occurred]', e);

      // 不要になったのでコメントアウト
      // const hiddenLotteryErrorParent = document.getElementById("hiddenLotteryErrorParent-" + view);
      // if (hiddenLotteryErrorParent) {
      //   hiddenLotteryErrorParent.value = e.stack;
      // }

      const cartForm = document.getElementById('cart');
      cartForm.action = '/checkout';
      cartForm.submit();
    }
  });
}

//////////////////////////////////////////////////
// カート画面読み込み時にgift同意、抽選結果のcartAttributeクリア
//////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  let dataObj = new Date();
  let year = dataObj.getFullYear();
  let month = ('00' + (dataObj.getMonth() + 1)).slice(-2);
  let date = ('00' + dataObj.getDate()).slice(-2);
  let hour = ('00' + dataObj.getHours()).slice(-2);
  let minute = ('00' + dataObj.getMinutes()).slice(-2);
  let second = ('00' + dataObj.getSeconds()).slice(-2);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        isAgreeGiftOrder: '',
        抽選結果: '',
        抽選結果当選コード: '',
        抽選結果当選コード名称: '',
        抽選エラー1: '',
        抽選エラー2: '',
        isClickSubmitButton: '',
        cartDispTime: year + '/' + month + '/' + date + ' ' + hour + ':' + minute + ':' + second,
        // atone A/Bテスト：群判別用。main-cart-items.liquid のhidden inputと同じ値にすること。
        // テスト終了後はこの行を削除する。
        _atone_ab_group: 'control',
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }
    })
    .catch((error) => {
      console.error(error);
    });
});
